import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <rect width={22} height={22} x={5} y={5} fill="#FFD3FF" rx={2} />
    <path
      fill="#CD56BD"
      fillRule="evenodd"
      d="M11 17c.35 0 .687.06 1 .17V12a1 1 0 0 1 .758-.97l8-2A1 1 0 0 1 22 10v8a3 3 0 1 1-2-2.83v-3.89l-6 1.5V20a3 3 0 1 1-3-3m0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2m8-2a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
      clipRule="evenodd"
    />
    <path
      fill="#CD56BD"
      fillRule="evenodd"
      d="M4 7a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3zm3-1h18a1 1 0 0 1 1 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconFileAudio = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconFileAudio);
export default Memo;
